module.exports = __webpack_public_path__ + "static/media/location-icon-atlas-2-white.6ed91a85.png";